import firebase, { apps, database } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/analytics";
import "firebase/storage";
import { REALDB_CONSTANT } from "../Constant/FirebaseConstant";
import * as XLSX from "xlsx";
import { NotifyEvenuefy } from "../3rdParty";

const firebaseConfig = {
  apiKey: "AIzaSyBBgAbHlaczfUI-X1aKaQFIre8b1O7sfW8",
  authDomain: "iijs-floorplan.firebaseapp.com",
  databaseURL: "https://iijs-floorplan-default-rtdb.firebaseio.com",
  projectId: "iijs-floorplan",
  storageBucket: "iijs-floorplan.appspot.com",
  messagingSenderId: "144359212350",
  appId: "1:144359212350:web:d734da9f4f6f933e89986f",
  measurementId: "G-4ZFBF8M91S",
};

firebase.initializeApp(firebaseConfig);

export const firebaseApp = firebase;

export const auth = firebase.auth();

export const firestore = firebase.firestore();

export const realDB = firebase.database();

export const analytics = firebase.analytics();

export const storage = firebase.storage();

export const logoutUser = () => {
  return auth.signOut();
};

export const GetSellersBaseData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const snapshot = await realDB.ref(REALDB_CONSTANT.SellerBaseData).get();
      const snapshot = await realDB
        .ref(REALDB_CONSTANT.SellerBaseData)
        .once("value");
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Sellers Base Data found!!");
        resolve({});
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const GetSingleSellerBaseData = (sellerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await realDB
        .ref(`${REALDB_CONSTANT.SellerBaseData}/${sellerId}`)
        .get();
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Seller Base Data found!!");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const GetAllSellersStallData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const snapshot = await realDB.ref(REALDB_CONSTANT.Sellersdata).get();
      const snapshot = await realDB
        .ref(REALDB_CONSTANT.Sellersdata)
        .once("value");
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Sellers Stall Data found!!");
        resolve({});
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
export const GetSingleSellerStallData = (sellerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await realDB
        .ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`)
        .get();
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Seller Stall Data found!!");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const UpdateSellerStallData = (sellerId, payload, user) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!sellerId || !payload) {
        throw ({ code: "Parameter_UnFullfilled", message: "parameter not passed correctly" })
      }

      // const result = await NotifyEvenuefy.allocated(NotifyEvenuefy.SellersDataToNotifyData(payload))
      // console.log(result)
      // if (result.code != 200) {
      //   throw ({ code: "API_ERROR", message: "api occurred from API", data: result })
      // }
      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`);
      await nodeRef.update(payload);
      const _nodeRef = realDB.ref(
        `${REALDB_CONSTANT.SellerBaseData}/${sellerId}`
      );
      let _pa = {
        ...payload,
      };
      if (user) {
        _pa = {
          ..._pa,
          admin: {
            uid: user.uid,
            email: user.email,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          },
          // evenuefyResponse: {
          //   [new Date().getTime()]: result
          // }
        };
      }
      delete _pa.stallData;
      await _nodeRef.update(_pa);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const DeleteSellersStallData = (sellerId, sectionId, user) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!sellerId || !sectionId) {
        throw ({ code: "Parameter_UnFullfilled", message: "parameter not passed correctly" })
      }

      console.log("sellerId", sellerId)
      console.log("sectionId", sectionId)

      // const result = await NotifyEvenuefy.revoked(sellerId, sectionId)
      // console.log(result)
      // if (result.code != 200) {
      //   throw ({ code: "API_ERROR", message: "api occurred from API", data: result })
      // }

      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`);
      await nodeRef.remove();
      if (user) {
        const _nodeRef = realDB.ref(
          `${REALDB_CONSTANT.SellerBaseData}/${sellerId}`
        );
        _nodeRef.update({
          admin: {
            uid: user.uid,
            email: user.email,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          },
          // evenuefyResponse: {
          //   [new Date().getTime()]: result
          // }
        });
      }
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const getDataForExcel = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const baseNodeRef = realDB.ref(`${REALDB_CONSTANT.SellerBaseData}`);
      const baseNodeData = await baseNodeRef.get();
      if (!baseNodeData.exists()) {
        return;
      }
      let baseNodeDataObj = Object.values(baseNodeData.val());

      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}`);
      const nodeData = await nodeRef.get();
      let nodeDataObj = {};
      if (nodeData.exists()) {
        nodeDataObj = Object.values(nodeData.val());
      }
      console.log(nodeDataObj);

      let nodeDataObjHash = {};
      nodeDataObj.forEach((elementData) => {
        nodeDataObjHash[elementData.comapnyId] = {
          ...elementData,
        };
      });
      let result = baseNodeDataObj.map((_bnd) => {
        let _adminData = { ..._bnd.admin };
        delete _bnd.admin;

        let _r = {
          ..._bnd,
        };
        Object.keys(_adminData).forEach((k) => {
          _r[`Admin_${k}`] = _adminData[k];
        });
        if (nodeDataObjHash[_bnd.comapnyId]) {
          let stallsData = nodeDataObjHash[_bnd.comapnyId].stallData;
          Object.keys(stallsData).forEach((stallId, index) => {
            let _index = index + 1;
            let stallData = stallsData[stallId];
            Object.keys(stallData).forEach((k) => {
              _r[`Stall${_index}_${k}`] = stallData[k];
            });
          });
        }
        return _r;
      });
      console.log(result);
      exportFile(
        result,
        "sheet1",
        "IIJS_DATA" + new Date().getTime() + ".xlsx"
      );
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const exportFile = (
  data,
  sheetName,
  filename,
  headerOrdering = null
) => {
  try {
    console.log("exportFile");
    const wb = XLSX.utils.book_new();
    let wsAll = null;
    if (headerOrdering) {
      wsAll = XLSX.utils.json_to_sheet(data, {
        header: headerOrdering,
      });
    } else {
      wsAll = XLSX.utils.json_to_sheet(data);
    }
    XLSX.utils.book_append_sheet(wb, wsAll, sheetName);
    XLSX.writeFile(wb, filename);
  } catch (error) {
    console.error(error);
  }
};
window.getDataForExcel = getDataForExcel;

const newData = {
  "7000003177": {
    "comapnyId": 7000003177,
    "company_name": "DOIT INDUSTRIES INDIA PVT. LTD.",
    "section": "sectionData_13",
    "area": 72,
    "region": "HO-MUM (M)"
  },
  "7000013110": {
    "comapnyId": 7000013110,
    "company_name": "CASCADE STAR INDIA PVT. LTD.",
    "section": "sectionData_13",
    "area": 54,
    "region": "HO-MUM (M)"
  },
  "7000017336": {
    "comapnyId": 7000017336,
    "company_name": "M. SAKSHI INTERNATIONAL",
    "section": "sectionData_13",
    "area": 36,
    "region": "HO-MUM (M)"
  },
  "7000009464": {
    "comapnyId": 7000009464,
    "company_name": "NAVBHARAT CARBON CO. (BOMBAY)",
    "section": "sectionData_13",
    "area": 36,
    "region": "HO-MUM (M)"
  },
  "7000015133": {
    "comapnyId": 7000015133,
    "company_name": "EAGLE EXPORTS",
    "section": "sectionData_13",
    "area": 36,
    "region": "RO-SRT"
  },
  "7000070170": {
    "comapnyId": 7000070170,
    "company_name": "WESTERN EQUIPMENTS AND sectionData_12 PVT LTD",
    "section": "sectionData_13",
    "area": 36,
    "region": "HO-MUM (M)"
  },
  "7000049695": {
    "comapnyId": 7000049695,
    "company_name": "CAST TECH INTERNATIONAL",
    "section": "sectionData_13",
    "area": 27,
    "region": "HO-MUM (M)"
  },
  "7000017323": {
    "comapnyId": 7000017323,
    "company_name": "GESSWEIN TRADING PVT. LTD.",
    "section": "sectionData_13",
    "area": 27,
    "region": "HO-MUM (M)"
  },
  "7000078437": {
    "comapnyId": 7000078437,
    "company_name": "MILLENIA TECHNOLOGIES (I) PVT LTD",
    "section": "sectionData_13",
    "area": 27,
    "region": "HO-MUM (M)"
  },
  "7000017255": {
    "comapnyId": 7000017255,
    "company_name": "ACZET PVT. LTD.",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017507": {
    "comapnyId": 7000017507,
    "company_name": "AMAR MACHINE TOOLS",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-DEL"
  },
  "7000003155": {
    "comapnyId": 7000003155,
    "company_name": "ANKITST EXIM INC",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000044071": {
    "comapnyId": 7000044071,
    "company_name": "ARIHANT ENTERPRISE",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000004626": {
    "comapnyId": 7000004626,
    "company_name": "ASHLYN CHEMUNNOOR INSTRUMENTS  PVT LTD",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-CHE"
  },
  "7000017259": {
    "comapnyId": 7000017259,
    "company_name": "DARSHAN JEWEL TOOLS PVT. LTD.",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000010601": {
    "comapnyId": 7000010601,
    "company_name": "D-MAX",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017488": {
    "comapnyId": 7000017488,
    "company_name": "FISCHER MEASUREMENT TECHNOLOGI ES (INDIA) PVT LTD",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017296": {
    "comapnyId": 7000017296,
    "company_name": "GARG ELECTROHEAT",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000080547": {
    "comapnyId": 7000080547,
    "company_name": "K-JHIL SCIENTIFIC PVT LTD",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-SRT"
  },
  "7000061238": {
    "comapnyId": 7000061238,
    "company_name": "KRISHNA ENTERPRISE",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000004772": {
    "comapnyId": 7000004772,
    "company_name": "MODERN CHAIN MACHINES",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-DEL"
  },
  "7000004092": {
    "comapnyId": 7000004092,
    "company_name": "N JEWELLERY TECHNIQUES PVT LTD",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017263": {
    "comapnyId": 7000017263,
    "company_name": "NICKUNJ EXIMP ENTP  P.LTD.",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000061188": {
    "comapnyId": 7000061188,
    "company_name": "RAVI MALVIYA INDUSTRIES PRIVATE LIMITED",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-SRT"
  },
  "7000012273": {
    "comapnyId": 7000012273,
    "company_name": "RAVINDRA HERAEUS PVT.LTD",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-JAI"
  },
  "7000017344": {
    "comapnyId": 7000017344,
    "company_name": "RIDDHI HEATRON",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000057644": {
    "comapnyId": 7000057644,
    "company_name": "RTECH INDIA",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017321": {
    "comapnyId": 7000017321,
    "company_name": "S.R. MEHTA & SONS",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000012801": {
    "comapnyId": 7000012801,
    "company_name": "SAHAJANAND LASER TECHNOLOGY LIMITED",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-SRT"
  },
  "7000009471": {
    "comapnyId": 7000009471,
    "company_name": "SAMYAK TOOLS",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000069529": {
    "comapnyId": 7000069529,
    "company_name": "SHREE RAPID TECHNOLOGIES",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000069667": {
    "comapnyId": 7000069667,
    "company_name": "SUNNY MACHINERIES",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-SRT"
  },
  "7000061325": {
    "comapnyId": 7000061325,
    "company_name": "UNIQUE4KEY",
    "section": "sectionData_13",
    "area": 18,
    "region": "RO-SRT"
  },
  "7000017346": {
    "comapnyId": 7000017346,
    "company_name": "WELL WORTH ENGINEERING",
    "section": "sectionData_13",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000009270A": {
    "comapnyId": "7000009270A",
    "company_name": "PIERCING SYSTEMS INDIA PVT.  LTD.",
    "section": "sectionData_12",
    "area": 36,
    "region": "HO-MUM (M)"
  },
  "7000013829": {
    "comapnyId": 7000013829,
    "company_name": "AGKEM IMPEX PRIVATE LIMITED",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000052405": {
    "comapnyId": 7000052405,
    "company_name": "ANANT JEWELS AND TECHNOLOGIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000049697": {
    "comapnyId": 7000049697,
    "company_name": "ANANT LAXMI DIEMAKERS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000053155": {
    "comapnyId": 7000053155,
    "company_name": "AONE DIAMOND AIDS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000003056": {
    "comapnyId": 7000003056,
    "company_name": "APX INTERNATIONAL",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000009167": {
    "comapnyId": 7000009167,
    "company_name": "ARIHANT MAXSELL TECHNOLOGIES PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000044046": {
    "comapnyId": 7000044046,
    "company_name": "ASTRICK INTERNATIONAL",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000060992": {
    "comapnyId": 7000060992,
    "company_name": "ATULYEA CHAINS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000075778": {
    "comapnyId": 7000075778,
    "company_name": "BHARAT MACHINE TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000012002": {
    "comapnyId": 7000012002,
    "company_name": "BLUESTAR CHEMICALS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000008184": {
    "comapnyId": 7000008184,
    "company_name": "ETERNA INDUSTRIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000080268": {
    "comapnyId": 7000080268,
    "company_name": "EUROTECNICHE INDIA PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017360": {
    "comapnyId": 7000017360,
    "company_name": "GOLD SIDE PRODUCTION",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000069747": {
    "comapnyId": 7000069747,
    "company_name": "GOODWIN REFRACTORY SERVICES INDIA PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000010358": {
    "comapnyId": 7000010358,
    "company_name": "HARITHA AUTOMATION PVT. LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000052450": {
    "comapnyId": 7000052450,
    "company_name": "HEMNAV VENTURES PRIVATE LIMITED",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000069945": {
    "comapnyId": 7000069945,
    "company_name": "IGNITE INDUCTION LLP",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000004746": {
    "comapnyId": 7000004746,
    "company_name": "IMAGINARIUM SOLUTIONS (I)  PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017294": {
    "comapnyId": 7000017294,
    "company_name": "INTRIGUITY",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000026312": {
    "comapnyId": 7000026312,
    "company_name": "JEWELTECH",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000001902": {
    "comapnyId": 7000001902,
    "company_name": "JOHARI GEMS & TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-JAI"
  },
  "7000063281": {
    "comapnyId": 7000063281,
    "company_name": "KARAN MARKING SYSTEMS PVT. LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000049462": {
    "comapnyId": 7000049462,
    "company_name": "KAUSTUBHH TECHNOCRAFT",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000080620": {
    "comapnyId": 7000080620,
    "company_name": "LUCKY TRADERS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000046065": {
    "comapnyId": 7000046065,
    "company_name": "LVS MACHINE TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000047292": {
    "comapnyId": 7000047292,
    "company_name": "MAGNIC TECHNOLOGIES PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000057421": {
    "comapnyId": 7000057421,
    "company_name": "MAKE3D.IN",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000080523": {
    "comapnyId": 7000080523,
    "company_name": "MECEKA GRAPHITE PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017358": {
    "comapnyId": 7000017358,
    "company_name": "METRO ELECTRIC COMPANY",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000037792": {
    "comapnyId": 7000037792,
    "company_name": "MOON sectionData_13 MART",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000080178": {
    "comapnyId": 7000080178,
    "company_name": "N. K. INDUSTRIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000002157": {
    "comapnyId": 7000002157,
    "company_name": "NAVBHARAT JEWELLERY TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000011591": {
    "comapnyId": 7000011591,
    "company_name": "NEO INSTRUMENT CO",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000002071": {
    "comapnyId": 7000002071,
    "company_name": "NUCLEUS ANALYTICS PRIVATE   LIMITED",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000053110": {
    "comapnyId": 7000053110,
    "company_name": "P AND S CHEMITECH",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000017317": {
    "comapnyId": 7000017317,
    "company_name": "PAPPU ENGINEERING WORKS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000060926": {
    "comapnyId": 7000060926,
    "company_name": "PARESH TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017354": {
    "comapnyId": 7000017354,
    "company_name": "PRECIOUS ALLOYS PVT. LTD.",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000011100": {
    "comapnyId": 7000011100,
    "company_name": "PROFESSIONAL ENGINEERING WORKS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000006670": {
    "comapnyId": 7000006670,
    "company_name": "PROGOLD INDIA",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017283": {
    "comapnyId": 7000017283,
    "company_name": "QUANTUM EQUIPMENT CO.PVT. LTD.",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000005200": {
    "comapnyId": 7000005200,
    "company_name": "R R IMPEX",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000004128": {
    "comapnyId": 7000004128,
    "company_name": "RAJ ELECTRIC WORKS(MUMBAI)",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000003185": {
    "comapnyId": 7000003185,
    "company_name": "RAMANA JEVAR EQUIPMENTS  & SUPPLIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000009906": {
    "comapnyId": 7000009906,
    "company_name": "RANSA INC",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000061510": {
    "comapnyId": 7000061510,
    "company_name": "RT INTERNATIONAL",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-JAI"
  },
  "7000004101": {
    "comapnyId": 7000004101,
    "company_name": "SACHI",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-JAI"
  },
  "7000010031": {
    "comapnyId": 7000010031,
    "company_name": "SAPNA METALS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000015237": {
    "comapnyId": 7000015237,
    "company_name": "SARTO ELECTRO EQUIPMENT PVT.LT D.",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000060839": {
    "comapnyId": 7000060839,
    "company_name": "SCULPTORIS INNOVATION PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000069989": {
    "comapnyId": 7000069989,
    "company_name": "SEMSONS INTERNATIONAL",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000003346": {
    "comapnyId": 7000003346,
    "company_name": "SHAH TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000080475": {
    "comapnyId": 7000080475,
    "company_name": "SHAPET INDUCTION COMPANY",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000079624": {
    "comapnyId": 7000079624,
    "company_name": "SHREEHARI ELECTROCHEM LLP",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000010187": {
    "comapnyId": 7000010187,
    "company_name": "SOLANKI MECHANIC WORKS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000017290": {
    "comapnyId": 7000017290,
    "company_name": "SONI ENTERPRISE",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000066801": {
    "comapnyId": 7000066801,
    "company_name": "SPARKLE LASER TECHNOLOGY LLP",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000079963": {
    "comapnyId": 7000079963,
    "company_name": "TISHYA CNC ENGINNERING WORKS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000008936": {
    "comapnyId": 7000008936,
    "company_name": "V.J. ENTERPRISES",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017356": {
    "comapnyId": 7000017356,
    "company_name": "VENUS PRECIOUS METALS REFINERY",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000009576": {
    "comapnyId": 7000009576,
    "company_name": "WILL & WISDOM",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000014824": {
    "comapnyId": 7000014824,
    "company_name": "WILMOR ENTERPRISE",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000017480": {
    "comapnyId": 7000017480,
    "company_name": "WINTECH JEWELS EQUIPMENT PVT.  LTD.",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000008780": {
    "comapnyId": 7000008780,
    "company_name": "YASUI FIELD ENGINEERING P. LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000044364": {
    "comapnyId": 7000044364,
    "company_name": "CHAMPION SCALES",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000045137": {
    "comapnyId": 7000045137,
    "company_name": "ENGINEERING TECHNIQUE",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000055387": {
    "comapnyId": 7000055387,
    "company_name": "H.K. INDUSTRIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000077845": {
    "comapnyId": 7000077845,
    "company_name": "H.K. MALVI INDUSTRIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000003153": {
    "comapnyId": 7000003153,
    "company_name": "HARSHDA AUTOMATION INDUSTRIES",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000078196": {
    "comapnyId": 7000078196,
    "company_name": "JD DESIGNS & TECHNOLOGY",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000044367": {
    "comapnyId": 7000044367,
    "company_name": "K TECH ENTERPRISES",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000061515": {
    "comapnyId": 7000061515,
    "company_name": "MAK GOLD",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000078313": {
    "comapnyId": 7000078313,
    "company_name": "Micronalytik instrumental Pvt Ltd",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000034337": {
    "comapnyId": 7000034337,
    "company_name": "MICROTECH INSTRUMENTS CORPORATION",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000034331": {
    "comapnyId": 7000034331,
    "company_name": "SHRIJI TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000044377": {
    "comapnyId": 7000044377,
    "company_name": "UNNATI EXIMP INTERNATONAL",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000044359": {
    "comapnyId": 7000044359,
    "company_name": "ZAI JEWELLERY TOOLS",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000080615": {
    "comapnyId": 7000080615,
    "company_name": "AGILE MACHINERIES PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000069955": {
    "comapnyId": 7000069955,
    "company_name": "ALPHA E BARCODE SOLUTIONS PVT LTD",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000069866": {
    "comapnyId": 7000069866,
    "company_name": "MICROMAC INDUSTRIES PRIVATE LIMITED",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000070021": {
    "comapnyId": 7000070021,
    "company_name": "KARAT 24 PROJECTS",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000066835": {
    "comapnyId": 7000066835,
    "company_name": "PRECISE PIERCING PRODUCTS INDIA LLP",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000076459": {
    "comapnyId": 7000076459,
    "company_name": "MAX POWER INDUCTION",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000080612": {
    "comapnyId": 7000080612,
    "company_name": "G.R.S. JEWELL TECNOLOGY LLP",
    "section": "sectionData_13",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000077690": {
    "comapnyId": 7000077690,
    "company_name": "TECHNOCAST MACHINE AND TOOLS LLP",
    "section": "sectionData_13",
    "area": 9,
    "region": "RO-JAI"
  },
  "7000009375": {
    "comapnyId": 7000009375,
    "company_name": "PACIO PACK LLP",
    "section": "sectionData_12",
    "area": 54,
    "region": "RO-CHE"
  },
  "7000004345": {
    "comapnyId": 7000004345,
    "company_name": "ARTISTRY INC.",
    "section": "sectionData_12",
    "area": 36,
    "region": "HO-MUM (M)"
  },
  "7000002258": {
    "comapnyId": 7000002258,
    "company_name": "P K TRADERS",
    "section": "sectionData_12",
    "area": 36,
    "region": "RO-CHE"
  },
  "7000060616": {
    "comapnyId": 7000060616,
    "company_name": "SHREE RAJ MARKETING",
    "section": "sectionData_12",
    "area": 27,
    "region": "RO-CHE"
  },
  "7000003937": {
    "comapnyId": 7000003937,
    "company_name": "ANAND PACKAGING",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-DEL"
  },
  "7000003160": {
    "comapnyId": 7000003160,
    "company_name": "CHANDAN AGENCIES",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017380": {
    "comapnyId": 7000017380,
    "company_name": "D SOFT INFOTECH PVT LTD",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-SRT"
  },
  "7000060947": {
    "comapnyId": 7000060947,
    "company_name": "DT EXPORTS",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-DEL"
  },
  "7000052731": {
    "comapnyId": 7000052731,
    "company_name": "ENDORA INTERIORS",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-CHE"
  },
  "7000005085": {
    "comapnyId": 7000005085,
    "company_name": "HARI KIRPA JEWELS",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-DEL"
  },
  "7000047711": {
    "comapnyId": 7000047711,
    "company_name": "IRYS (INDIA) R&D PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000060985": {
    "comapnyId": 7000060985,
    "company_name": "J R LABELWALA AND CO",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000017433": {
    "comapnyId": 7000017433,
    "company_name": "MAHAVIR PRODUCTS",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000048444": {
    "comapnyId": 7000048444,
    "company_name": "MANOHAR LAL AND SONS",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-JAI"
  },
  "7000008407": {
    "comapnyId": 7000008407,
    "company_name": "MEGANET INFOTECH PVT. LTD.",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000003168": {
    "comapnyId": 7000003168,
    "company_name": "RAJESH ENTERPRISES",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000048438": {
    "comapnyId": 7000048438,
    "company_name": "THE BOMBAY DISPLAY COMPANY",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000003932": {
    "comapnyId": 7000003932,
    "company_name": "UJWAL PLASTICS",
    "section": "sectionData_12",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000051583": {
    "comapnyId": 7000051583,
    "company_name": "ORNAWARE FINESSE PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 18,
    "region": "RO-KOL"
  },
  "7000017415": {
    "comapnyId": 7000017415,
    "company_name": "ACME INFOVISION SYSTEMS PVT. LTD.",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000054675": {
    "comapnyId": 7000054675,
    "company_name": "BOSON PACKAGING",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000003991": {
    "comapnyId": 7000003991,
    "company_name": "GATISOFTTECH",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000007035": {
    "comapnyId": 7000007035,
    "company_name": "INDIGO PRINTS PVT. LTD.",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000017348": {
    "comapnyId": 7000017348,
    "company_name": "INTERNATIONAL JOURNAL HOUSE",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-JAI"
  },
  "7000053153": {
    "comapnyId": 7000053153,
    "company_name": "INVIZIO SOLUTIONS LLP",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000005306": {
    "comapnyId": 7000005306,
    "company_name": "IQTEK SOFTWARE LTD",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000016869": {
    "comapnyId": 7000016869,
    "company_name": "JAIPUR JEWELLERY SHOW",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-JAI"
  },
  "7000075842": {
    "comapnyId": 7000075842,
    "company_name": "JKGOLD CHEMICALS PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000012781": {
    "comapnyId": 7000012781,
    "company_name": "KATARIA JEWELLERY INSURANCE CONSULTANCY",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000037828": {
    "comapnyId": 7000037828,
    "company_name": "KHUSHBOO NOVELTIES",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000006236": {
    "comapnyId": 7000006236,
    "company_name": "M M I SOFTWARES PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000017280": {
    "comapnyId": 7000017280,
    "company_name": "MADHUSHREE NOVELTIES",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-KOL"
  },
  "7000012316": {
    "comapnyId": 7000012316,
    "company_name": "NIMBUS SYSTEMS PVT. LTD",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-KOL"
  },
  "7000061305": {
    "comapnyId": 7000061305,
    "company_name": "ORAIL SERVICES",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-SRT"
  },
  "7000001967": {
    "comapnyId": 7000001967,
    "company_name": "PACIDEA",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-KOL"
  },
  "7000061094": {
    "comapnyId": 7000061094,
    "company_name": "PACKZILLA PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-KOL"
  },
  "7000053258": {
    "comapnyId": 7000053258,
    "company_name": "PARSHNATH BOXES",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000012881": {
    "comapnyId": 7000012881,
    "company_name": "SHARAAN INFOSYSTEMS",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000015082": {
    "comapnyId": 7000015082,
    "company_name": "SYNERGICS SOLUTIONS  PVT. LTD.",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000066337": {
    "comapnyId": 7000066337,
    "company_name": "TANIKA TECH JEWELS PVT.LTD",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000057664": {
    "comapnyId": 7000057664,
    "company_name": "TRIOLOGIC ENTERPRISES PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000053485": {
    "comapnyId": 7000053485,
    "company_name": "UNILIGHT INSURANCE BROKERS PVT. LTD",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000017307": {
    "comapnyId": 7000017307,
    "company_name": "VAISHALI BOOK CENTRE",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000061623": {
    "comapnyId": 7000061623,
    "company_name": "VISION BOARD STUDIO",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000061082": {
    "comapnyId": 7000061082,
    "company_name": "VM DESIGN GROUP",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000034346": {
    "comapnyId": 7000034346,
    "company_name": "DM INVENT PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000059572": {
    "comapnyId": 7000059572,
    "company_name": "RETAIL JEWELLER INDIA",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000002970": {
    "comapnyId": 7000002970,
    "company_name": "VANDNA INTERNATIONAL",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-DEL"
  },
  "7000080087": {
    "comapnyId": 7000080087,
    "company_name": "ZITHARA TECHNOLOGIES PVT LTD",
    "section": "sectionData_12",
    "area": 9,
    "region": "RO-CHE"
  },
  "7000076658": {
    "comapnyId": 7000076658,
    "company_name": "BLUESTONE TECH LABS PVT LTD",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000044375": {
    "comapnyId": 7000044375,
    "company_name": "SHAKTI ENTERPRISE",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000080281": {
    "comapnyId": 7000080281,
    "company_name": "SHEEN AI",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000066398": {
    "comapnyId": 7000066398,
    "company_name": "INSTA LAXMI PRIVATE LIMITED",
    "section": "sectionData_12",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000080458": {
    "comapnyId": 7000080458,
    "company_name": "SAFE PIERCING MEDICAL EQUIPMENTS LLC",
    "section": "sectionData_14",
    "area": 36,
    "region": "HO-MUM (M)"
  },
  "7000059636": {
    "comapnyId": 7000059636,
    "company_name": "ALPRESS DESIGN MOULD CONSULTING LTD",
    "section": "sectionData_14",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000034766": {
    "comapnyId": 7000034766,
    "company_name": "FASTI INDUSTRIALE SPA",
    "section": "sectionData_14",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000070253": {
    "comapnyId": 7000070253,
    "company_name": "GRS TOOLS/GLENDO",
    "section": "sectionData_14",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000082235": {
    "comapnyId": 7000082235,
    "company_name": "ATLIHAN MOULD & JEWELLERY MACHİNE",
    "section": "sectionData_14",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000082234": {
    "comapnyId": 7000082234,
    "company_name": "BRIEN3D",
    "section": "sectionData_14",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000045707": {
    "comapnyId": 7000045707,
    "company_name": "SCHULTHEISS GMBH",
    "section": "sectionData_14",
    "area": 18,
    "region": "HO-MUM (M)"
  },
  "7000044402": {
    "comapnyId": 7000044402,
    "company_name": "AFRA INTERNATIONAL FZC",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000034769": {
    "comapnyId": 7000034769,
    "company_name": "CIEMMEO",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000035320": {
    "comapnyId": 7000035320,
    "company_name": "GIUSTI TECH SRL",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000070397": {
    "comapnyId": 7000070397,
    "company_name": "GOLDEN MACHINE EQUIPMENT MANUFACTURING LLC",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000045706": {
    "comapnyId": 7000045706,
    "company_name": "GUVEN-IS KUYUMCULUK KALIPCILIK INS. SAN. VE TIC.LTD.STI",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000044405": {
    "comapnyId": 7000044405,
    "company_name": "ITALIMPIANTI ORAFI SPA",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000048150": {
    "comapnyId": 7000048150,
    "company_name": "J.T.E",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000047263": {
    "comapnyId": 7000047263,
    "company_name": "MASTERIX SRL",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000034327": {
    "comapnyId": 7000034327,
    "company_name": "OMBI SRL",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000034767": {
    "comapnyId": 7000034767,
    "company_name": "UNITED PMR INC",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000079315": {
    "comapnyId": 7000079315,
    "company_name": "VIOLI MACCHINE SRL",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000070192": {
    "comapnyId": 7000070192,
    "company_name": "ZVI YEHUDA",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000034770": {
    "comapnyId": 7000034770,
    "company_name": "SISMA SPA",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000082229": {
    "comapnyId": 7000082229,
    "company_name": "EISHIN TECHNOLOGY CO.,LTD.",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000082230": {
    "comapnyId": 7000082230,
    "company_name": "GALLORINI ALLOYS",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000082231": {
    "comapnyId": 7000082231,
    "company_name": "NOVIN LASER SABA",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000082232": {
    "comapnyId": 7000082232,
    "company_name": "PINO ALIPRANDINI TRADING LLC",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000082236": {
    "comapnyId": 7000082236,
    "company_name": "SIRO LASERTEC GMBH",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  },
  "7000082233": {
    "comapnyId": 7000082233,
    "company_name": "WORLD JEWELRY TOOLS CO.LTD.",
    "section": "sectionData_14",
    "area": 9,
    "region": "HO-MUM (M)"
  }
}

const data = {
  "7000009270B": {
    "comapnyId": "7000009270B",
    "company_name": "PIERCING SYSTEMS INDIA PVT.  LTD.",
    "section": "sectionData_13",
    "area": 18,
    "region": "region2",
  },
}

export const setSellersBaseData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      // const snapshot = realDB.ref('/2022_sprint_3/test');
      console.log(newData[Object.keys(newData)[0]])
      await snapshot.update(newData);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

// console.log(data);

export const setNode = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(data);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const updateExhibitorData = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(data);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

window.setSellersBaseData = setSellersBaseData;
window.setNode = setNode;
